import IconApartment from "@/app/icons/apartment.svg";
import BigText from "@/app/_components/Shared/BigText";
import BadgeIcon from "@/app/icons/badge.svg";
import VisaIcon from "@/app/icons/visa.svg";

export const servicesData = [
    {
        "title": "Visa Management",
        "icon": VisaIcon,
    },
    {
        "title": "Trade Licenses",
        "icon": BadgeIcon,
    },
    {
        "title": "Government Liaison",
        "icon": IconApartment,
    },
    {
        "title": (<BigText >10+</BigText>),
    },
];
export const plans = [
    {
        "title": "Silver",
        "type": "silver",
        "description": (<p>1. For businesses with 1-5 transactions per month. <br/>
            2. Includes essential PRO services with access to our basic dashboard.</p>),
    },
    {
        "title": "Gold",
        "type": "gold",
        "description": (<p>1. For businesses with 1-5 transactions per month. <br/>
            2. Includes essential PRO services with access to our basic dashboard.</p>),
    },
    {
        "title": "Platinum",
        "type": "platinum",
        "description": (<p>1. For businesses with 1-5 transactions per month. <br/>
            2. Includes essential PRO services with access to our basic dashboard.</p>),
    },
];

export const questions = [];